import React from 'react';
import ViewNavigation from '../parts/ViewNavigation';

export default class QuartersView extends React.Component {
    render() {
        return (
            <div className="rdtMonths">
                <table>
                    <thead>
                        { this.renderNavigation() }
                    </thead>
                </table>
                <table>
                    <tbody>
                        { this.renderQuarters() }
                    </tbody>
                </table>
            </div>
        );
    }

    renderNavigation() {
        let year = this.props.viewDate.year();

        return (
            <ViewNavigation
                onClickPrev={ () => this.props.navigate( -1, 'years' ) }
                onClickSwitch={ () => this.props.showView( 'years' ) }
                onClickNext={ () => this.props.navigate( 1, 'years' ) }
                switchContent={ year }
                switchColSpan="2"
            />
        );
    }

    renderQuarters() {
        // 12 months in 2 rows for every view
        let rows = [ [], [] ];

        for ( let month = 0; month < 12; month += 3 ) {
            let row = getRow( rows, month );

            row.push( this.renderQuarter( month ) );
        }

        return rows.map( (months, i) => (
            <tr key={i}>{ months }</tr>
        ));
    }

    renderQuarter(month ) {
        const selectedDate = this.props.selectedDate;
        let className = 'rdtMonth';
        let onClick;

        if ( this.isDisabledQuarter( month ) ) {
            className += ' rdtDisabled';
        }
        else {
            onClick = this._updateSelectedMonth;
        }

        if ( selectedDate && selectedDate.year() === this.props.viewDate.year() && selectedDate.month() === month ) {
            className += ' rdtActive';
        }

        let props = {key: month, className, 'data-value': month, onClick };

        if ( this.props.renderMonth ) {
            return this.props.renderMonth(
                props,
                month,
                this.props.viewDate.year(),
                this.props.selectedDate && this.props.selectedDate.clone()
            );
        }

        return (
            <td { ...props }>
                { QuartersView.getQuarterText( month ) }
            </td>
        );
    }

    isDisabledQuarter( month ) {
        let isValidDate = this.props.isValidDate;

        if ( !isValidDate ) {
            // If no validator is set, all days are valid
            return false;
        }

        // If one day in the quarter is valid, the year should be clickable
        let date = this.props.viewDate.clone().set({month});
        let day = date.endOf( 'quarter' ).date() + 1;

        while ( day-- > 1 ) {
            if ( isValidDate( date.date(day) ) ) {
                return false;
            }
        }
        return true;
    }

    static getQuarterText( month ) {
        let monthNum = Number(month);
        if (Number.isInteger(monthNum)) {
            return 'Q' + (Math.ceil((monthNum + 1) / 3));
        }
        return month;
    }

    _updateSelectedMonth = event => {
        this.props.updateDate( event );
    }
}

function getRow( rows, month ) {
    if ( month < 6 ) {
        return rows[0];
    }

    return rows[1];
}
